import { View, Text, StyleSheet, Image, TouchableOpacity } from 'react-native'
import React from 'react'
import Colours from '../../utils/Colours'
import BackArrow from '../../icons/BackArrow'
import { useNavigation } from '@react-navigation/native';
import { LinearGradient } from 'expo-linear-gradient'; // Import the LinearGradient component
import LocationIcon from '../../icons/LocationIcon';
import CalenderIcon from '../../icons/CalenderIcon';



const HeaderaPullScreen = ({ pullsData, setShowAPullScreen }) => {
  const navigate = useNavigation();
  return (
    <View>
      <TouchableOpacity style={styles.backBtnContainer}
        onPress={() => setShowAPullScreen(false)}>
        <BackArrow color={'white'} />
      </TouchableOpacity>
      <View style={styles.pullCaptionContainer}>
        <View style={styles.categoryJoinedSubContainer}>
          <Text style={{ color: 'white', marginTop: 240, fontSize: 20, fontFamily: 'Sen-Bold' }} >{pullsData?.pullCaption}</Text>
          <View style={styles.categorySubContainer}>
            <Text style={{ fontSize: 10, fontFamily: 'Sen-Regular', color: 'white' }}>{pullsData?.category}</Text>
          </View>
        </View>
        {/* <View style={styles.datesSubContainer}>
            <LocationIcon color={Colours.PRIMARY} width={15} height={15}/>
            <Text style={{color:'white', fontSize: 12, fontFamily:'Sen-Medium' }}>{pullsData?.location}</Text>
            </View> */}
        <View style={styles.datesSubContainer}>
          <CalenderIcon color={Colours.PRIMARY} width={15} height={15} />
          <Text style={{ color: 'white', fontSize: 12, fontFamily: 'Sen-Medium' }}>in Addy</Text>
        </View>
      </View>
      <View style={styles.headerImgContainer}>
        <Image source={{ uri: pullsData?.pictures }}
          style={styles.partyImg}
        />
        <LinearGradient
          colors={['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0.8)']} // Specify gradient colors
          style={styles.gradientOverlay} />

      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  headerImgContainer: {
    display: 'flex',
    height: 350,
    zIndex: 0,
    backgroundColor: Colours.PRIMARY_LIGHT
  },
  partyImg: {
    height: 350,
  },
  backBtnContainer: {
    position: 'absolute',
    zIndex: 10,
    padding: 20,
    marginTop: 20,
    // backgroundColor: 'white',

  },
  gradientOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    //zIndex:10,
    height: 250,
  },
  pullCaptionContainer: {
    display: 'flex',
    position: 'absolute',
    zIndex: 9,
    padding: 20,
    height: 400,
    gap: 5,
    // backgroundColor: 'white',
  },
  categorySubContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colours.PRIMARY,
    borderRadius: 5,
    // padding:5,
    width: 70,
    height: 20,
    marginTop: 240,

  },
  categoryJoinedSubContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 15,
    width: 200,
    //    backgroundColor: Colours.MIDGRAY
  },
  datesSubContainer: {
    display: 'flex',
    flexDirection: 'row',
    // justifyContent: 'space-between',
    alignItems: 'center',
    // alignContent:'center',
    gap: 5,
  }


})

export default HeaderaPullScreen